import { ModalsContainer, VueFinalModal } from 'vue-final-modal';
import { defineAsyncComponent } from 'vue';

export default {
    emits: ["close", "minimize", "restore", "maximize"],
    components: {
        ModalsContainer, VueFinalModal,
        OctoloModalv2: defineAsyncComponent(() => import('@/libraries/modal/index.vue'))
    },
    data: () => ({
        modals: [],
        formatUsed: undefined,
        dataHeight: {},
        observer: undefined,
        listActionClassic: [
            "canMinimize",
            "canMaximize",
            "canRestore",
            "canClose",
        ],
        listActionAlert: [
            "canClose",
        ],
    }),
    props: {
        contentnb: { type: Number, default: 1 },
        format: { type: String, default: "fix" },
        show: { type: [Boolean, Number, String], default: false },
        attrs: { type: Object, default(){ return {} }},
        alert: { type: Boolean, default: false },
        separate: { type: Array, default(){ return []; } },
        bgclass: { type: String },
        canMinimize: { type: Boolean, default: false },
        canMaximize: { type: Boolean, default: false },
        canRestore: { type: Boolean, default: false },
        canClose: { type: Boolean, default: false },
        canAll: { type: Boolean, default: false },
        noClickOutside: { type: Boolean, default: false },
        noEscToClose: { type: Boolean, default: false },
        enableOverflow: { type: Boolean, },
        loopclass: { type: [String, Array, Object], default: "" },
        modalsize: { type: String, default: "" },
        position: { type: String, default: "center", validator: v => ["left","center","right","left-bottom","left-top","right-bottom","right-top", "center-top", "center-bottom"].includes(v) },
        hideOverlay: { type: Boolean, default: false },
        interactiveBackground: { type: Boolean, default: false },
        modalWidth: { type: String, default: "auto" },
        modalHeight: { type: String, default: "auto" },
    },
    computed: {
        styleBgClass(){ return this.bgclass ? "background-color: "+this.bgclass : ""; },
        hasTitleOrAction(){ return (this.hasAction && !this.alert);},
        canShow(){ return (this.show || this.canShowURL) ? true : false; },
        canShowURL(){ return false; },
        hasAction(){
            if(this.canAll) return true;
            var nbaction = 0;
            var listAction = this.alert ? this.listActionAlert : this.listActionClassic;
            listAction.forEach(a => { if(this[a]) nbaction++; });
            return nbaction;
        },
        selectedFormat(){
            if(this.format == "fix" || this.modalsize == "fix") return "max-w-[600px] max-h-[70vh] my-[50px] mx-auto";
            if(this.format == "large" || this.modalsize == "large") return "max-w-[1200px] max-h-[85vh] my-[50px] mx-auto";
            if(this.format == "enlarge" || this.modalsize == "enlarge") return "!min-w-[85vw] !min-h-[85vh] !max-w-[85vw] !max-h-[85vh] !my-[50px] !mx-auto";
            if(this.format == "full" || this.modalsize == "full") return "h-screen w-full";
            return "";
        },
        justifyClass() {
            switch (this.position) {
            case "left":  return "justify-start";
            case "right": return "justify-end";
            case "left-top": return "justify-start items-start";
            case "left-bottom": return "justify-start items-end";
            case "right-top": return "justify-end items-start";
            case "right-bottom": return "justify-end items-end";
            case "center": return "justify-center items-center"
            case "center-top": return "justify-center items-start";
            case "center-bottom": return "justify-center items-end";
            default:      return "justify-center items-center";
            }
        },
    },
    methods: {
        openModal(modal){ this.modals[modal] = true; },
        closeModal(modal){ this.modals[modal] = false; },
        refName(name, i){ return i == 1 ? name : name+i; },
        needSeparator(pos){ return (this.separate.indexOf(pos) > -1) },
        marginHeight(){ return this.get_modal_height()-this.offsetMargin; },
        resizeModal(){ if(this.show) this.$refs.content.style.maxHeight = this.get_modal_height()+"px"; },
        closeCurrentModal(){
            if(this.modal) this.closeModalURL(this.modal);
            this.$emit("close", this.keep);
        },
        getLoopClass(i){
            if(Array.isArray(this.loopclass)) return this.loopclass[i];
            if(typeof this.loopclass == "object") return this.loopclass[i+1];
            return this.loopclass;
        },
        get_modal_height(){
            var mh = window.innerHeight - this.titleBorder - this.offsetModal - this.headerHeight - this.footerHeight;
            this.dataHeight = {
                header: this.headerHeight,
                content: mh,
                footer: this.footerHeight,
                offset: this.offsetModal,
                margin: this.marginHeight,
            };
            this.$emit("resize", this.dataHeight);
            return mh;
        }
    },
}
